import React from "react";
import { Icon, IconButton } from "../../../_components";

export function TimelinesManager() {
  return (
    <div className="chronos-help-topic-page chronos-timelines-manager-topic">
      <p>
        In the Timelines Manager, you can toggle visibility, edit, and delete
        your current timelines. You can search within your existing Chronicle
        Timelines using the search bar. You can also crate a new Timeline here
        using the "New Timeline" button.
      </p>
      <h3 className="chronos-topic-header">Toggle Visibility</h3>
      <p>
        <IconButton icon="fas fa-eye fa-fw" color="success" />
        &nbsp; Click the eye button to toggle a timeline as visible or
        invisible. This also removes it for your visitors, regardless of its
        public or private state. For quick access to this option, click the eye
        icon <Icon icon="fas fa-eye fa-fw" /> next to the name of your timeline
        on the bottom left.
      </p>
      <h3 className="chronos-topic-header">Edit Timeline</h3>
      <p>
        <IconButton icon="fas fa-pencil fa-fw" color="primary" />
        &nbsp; Here you can rename your timeline. You can also set your timeline
        as public or private for viewers. If your timeline is private, you can
        add subscriber groups with exclusive viewing access to it.
      </p>
      <p>
        For quick access to Timeline edit options, click the cog icon{" "}
        <Icon icon="fas fa-cog fa-fw" /> next to the name of your timeline on
        the bottom left.
      </p>
      <h3 className="chronos-topic-header">Delete Timeline</h3>
      <p>
        <IconButton icon="fas fa-pencil fa-fw" color="danger" />
        &nbsp; When a timeline is deleted, <strong>ALL EVENTS</strong> attached
        to it will <strong>ALSO</strong> be deleted. Deleting a timeline and
        associated events cannot be undone — your work will be lost. To delete a
        timeline, press the delete button, and confirm again on the Confirm
        Deletion window.
      </p>
      <p>
        You can use the Events Manager to mass-move events to another timeline.
        Otherwise, move them individually by right clicking on the event,
        selecting Edit Event, then selecting a different timeline from the
        Timeline dropdown.
      </p>
    </div>
  );
}
